module.exports = __webpack_public_path__ + "static/media/add_User.c6bc319e.svg";